import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from '../services/storage.service';
import { PopupService } from '../services/popup.service';
import { SKIP_TOKEN_HEADER } from '../services/utility.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

	constructor(
		private storageService: StorageService,
		private popupService: PopupService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.headers.has(SKIP_TOKEN_HEADER)) {
			request = request.clone({ body: request.body, headers: request.headers.delete(SKIP_TOKEN_HEADER), withCredentials: false });
		} else {
			let headers: HttpHeaders = new HttpHeaders();
			// HEADERS
			headers = headers.append('x-correlation-id', this.storageService.getFromSessionStorage('correlationId'))
				.append('Authorization', `Bearer ${this.storageService.getFromSessionStorage('accessToken')}`)
				.append('x-application-id', environment.x_app_id);
			let body = request.body;
			const token = this.storageService.getFromSessionStorage('token');
			if (token) {
				if (request.body instanceof FormData) {
					request.body.append('token', token);
				}
				else {
					body = {
						...request.body,
						...{ token }
					};
				}
			}
			request = request.clone({ body, headers, withCredentials: false });
		}
		return next.handle(request).pipe(
			catchError((error/*, caught*/) => {
				this.handleError(error);
				return of(error);
			}) as any);
	}

	/**
	 * Handle errors
	 */
	private handleError(err: HttpErrorResponse): Observable<HttpErrorResponse> {
		this.showPopup();
		throw err;
	}

	private showPopup(): void {
		this.popupService.show('WARNING', 'ERR_GEN');
	}
}
